function setHeaderHeight() {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const height = header.offsetHeight;

  document.documentElement.style.setProperty('--header-height', `${height}px`);
}
document.addEventListener('DOMContentLoaded', setHeaderHeight);
window.addEventListener('resize', setHeaderHeight);

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.services__title');
  const images = document.querySelectorAll('.services__content');

  function updateActiveImage() {
    const viewportCenter = (window.innerHeight / 2) - 120;

    let activeIndex = null;

    items.forEach((item) => {
      const rect = item.getBoundingClientRect();

      if (
        rect.top <= viewportCenter &&
        rect.bottom >= viewportCenter
      ) {
        activeIndex = item.dataset.index;
      }
    });

    items.forEach((item) => {
      item.classList.remove('active');

      if (item.dataset.index === activeIndex) {
        item.classList.add('active');
      }
    });

    images.forEach((image) => {
      image.classList.remove('active');

      if (image.dataset.index === activeIndex) {
        image.classList.add('active');
      }
    });
  }

  window.addEventListener('scroll', updateActiveImage);
  window.addEventListener('resize', updateActiveImage);

  updateActiveImage();
});

function updateSectionHeight() {
  const section = document.getElementById('shopify-section-template--29146403504511__custom_content_KRJqBQ');
  const firstSection = document.querySelector('#MainContent .shopify-section:first-child .multicolumn');

  if (!section || !firstSection) return;

  if (window.innerWidth < 750) return;

  const style = getComputedStyle(section);
  const totalHeight =
    section.offsetHeight +
    parseFloat(style.marginTop) +
    parseFloat(style.marginBottom);

  firstSection.style.minHeight = `calc(100vh - ${totalHeight}px)`;
}

document.addEventListener('DOMContentLoaded', updateSectionHeight);
window.addEventListener('resize', updateSectionHeight);


function equalH3Height() {
  document.querySelectorAll('.icon-with-text--section .multicolumn').forEach(section => {
    const headings = section.querySelectorAll('.icon-with-text--section .multicolumn-card__info h3');

    if (window.innerWidth < 750) return;

    let maxHeight = 0;

    headings.forEach(h3 => h3.style.minHeight = '');

    headings.forEach(h3 => {
      maxHeight = Math.max(maxHeight, h3.offsetHeight);
    });

    headings.forEach(h3 => {
      h3.style.minHeight = `${maxHeight}px`;
    });
  });
}

window.addEventListener('load', equalH3Height);
window.addEventListener('resize', equalH3Height);
document.addEventListener('shopify:section:load', equalH3Height);